import FraseSeleccionAplicacionPlantelActions from "./FraseSeleccionAplicacionPlantelActions";

const FraseSeleccionAplicacionPlantelRow = ({ frase, search }) => {
  const highlightText = (text) => {
    if (!search || search.length < 3) return text;
    const regex = new RegExp(`(${search})`, "gi");
    return text.replace(regex, "<mark>$1</mark>");
  };

  return (
    <tr>
      <td>{frase.id}</td>
      <td dangerouslySetInnerHTML={{ __html: highlightText(frase.frase || "-") }} />
      <td>
        <span
          className={`px-3 py-1 rounded-pill fw-medium text-sm ${
            frase.is_active
              ? "bg-success-focus text-success-main"
              : "bg-danger-focus text-danger-main"
          }`}
        >
          {frase.is_active ? "Activa" : "Inactiva"}
        </span>
      </td>
      <td>
        <span className="text-center text-neutral-700 text-xl">
          <FraseSeleccionAplicacionPlantelActions frase={frase} />
        </span>
      </td>
    </tr>
  );
};

const FrasesSeleccionAplicacionPlantelTable = ({ frases, search }) => {
  return (
    <div className="table-responsive">
      <table className="table bordered-table mb-0">
        <thead>
          <tr>
            <th>ID</th>
            <th>Frase</th>
            <th>Estado</th>
            <th className="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {frases.map((frase) => (
            <FraseSeleccionAplicacionPlantelRow key={frase.id} frase={frase} search={search} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FrasesSeleccionAplicacionPlantelTable;